/*
 * @Author: 张帮辉
 * @LastEditors: 彭鑫诚
 * @Date: 2022-06-06 14:48:49
 * @LastEditTime: 2024-10-21 11:04:03
 * @Description: 全局store
 */
import type { IAppModel, IAppStore } from '@monorepo/types/app/app.types';
import { Modal } from '@lemon-fe/kits';
import { $t } from '@monorepo/utils';
import { HOME_PAGE_NAME } from '@/components/AliveTabs/route-title';

const initState: IAppStore = {
  tabs: location.pathname.startsWith('/account')
    ? []
    : [
        {
          title: $t(HOME_PAGE_NAME),
          key: '/',
        },
      ],
  pageLoading: true,
  stockSetting: {
    product_price_precision: 4,
    receive_auto_sync_cost_price_is: false,
    audited_is: false,
    auto_store_in_hours: '',
    center_out_order_audit_direct_create_store_in_order_is: false,
    location_request_no_display_central_inventory: false,
    location_request_no_exceed_distribution_center_inventory: false,
    not_show_item_type_without_items_for_app: false,
    convert_actual_item: false,
    purchase_order_first_add_audit_is: false,
    transfer_order_first_add_audit_is: false,
    inventory_order_first_add_audit_is: false,
    request_template_required: false,
    request_template_location_id_list: [],
    transfer_in_create_by_transfer_out: false,
    transfer_in_audit_create_again_by_remain: false,
    autoMaintainPriceInterface: false,
    auto_maintain_purchase_unit_price: false,
    produce_order_first_add_audit_is: false,
    request_center_inventory_sub_not_transfer_amount: false,
    auto_generate_receive_by_purchase: false,
    staff_required_purchase: false,
    staff_required_production: false,
    staff_required_inventory: false,
    staff_required_transfer: false,
    staff_required_finance: false,
    finance_order_first_add_audit_is: false,
  },
};

const appStore: IAppModel = {
  namespace: 'appStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
  subscriptions: {
    setup({ history }) {
      // 监听 history 变化
      return history.listen(() => {
        Modal.destroyAll();
      });
    },
  },
};

export default appStore;
